import { render } from "./SalaDeEspera.vue?vue&type=template&id=314069cc&scoped=true"
import script from "./SalaDeEspera.vue?vue&type=script&lang=js"
export * from "./SalaDeEspera.vue?vue&type=script&lang=js"

import "./SalaDeEspera.vue?vue&type=style&index=0&id=314069cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-314069cc"]])

export default __exports__